import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { UrlparsePage } from './urlparse';

@NgModule({
  declarations: [
    UrlparsePage,
  ],
  imports: [
    IonicPageModule.forChild(UrlparsePage),
  ],
})
export class UrlparsePageModule {}



// WEBPACK FOOTER //
// ./src/pages/urlparse/urlparse.module.ts